import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col } from "reactstrap";
import QwikForm from "components/form/QwikForm";
import QwikInput from "components/form/QwikInput";
import { useUpdateCostingMutation } from "store/features/costing/costingManagementApi";
import { toast } from "sonner";

const EditCostingModal = ({ isOpen, toggle, costing, onCostingUpdate }) => {
  const [updateCosting, { isLoading }] = useUpdateCostingMutation();

  const handleSubmit = async (data) => {
    try {
      await updateCosting({ id: costing.id, ...data }).unwrap();
      toast.success("Costing updated successfully");
      onCostingUpdate();
    } catch (error) {
      toast.error("Failed to update costing");
      console.error('Costing update error:', error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Costing</ModalHeader>
      <QwikForm onSubmit={handleSubmit} defaultValues={costing}>
        <ModalBody>
          <Row>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="project_name"
                  label="Project Name"
                  placeholder="Enter project name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="item_name"
                  label="Item Name"
                  placeholder="Enter item name"
                  type="text"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="amount"
                  label="Amount"
                  placeholder="Enter amount"
                  type="number"
                  step="0.01"
                  className="form-control"
                  required
                />
              </div>
            </Col>
            <Col lg={12}>
              <div className="mb-3">
                <QwikInput
                  name="notes"
                  label="Notes"
                  placeholder="Enter any notes about this costing"
                  type="textarea"
                  className="form-control"
                  rows="3"
                />
              </div>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button type="button" color="light" onClick={toggle}>
            Cancel
          </Button>
          <Button type="submit" color="primary" disabled={isLoading}>
            {isLoading ? "Updating..." : "Update Costing"}
          </Button>
        </ModalFooter>
      </QwikForm>
    </Modal>
  );
};

export default EditCostingModal;